import { parseCommandByte } from './ProtocolHeader';

/**
 * 4.0 RT 校准。
 *
 * byte3 固定 0xF0，整包只需 4 个字节（cmd + 包序 + 长度/0xF0 + 值），
 * 每次只发一个值：
 *   byte4=1    → 放开按键阶段
 *   byte4=2    → 按下按键阶段
 *   byte4=0xFF → 保存并结束校准
 *
 * 协议没有单独的取消值，中途退出也发 0xFF 让设备离开校准模式。
 *
 * command=4 / byte3=0xF0：与 type1 传感器、type3/4 系统设置、0xF1/0xF2 监测、0xF3 配置错开。
 */
export const RT_CALIBRATE_COMMAND = 4;
export const RT_CALIBRATE_TYPE = 0xf0;
export const RT_CALIBRATE_PHASE_RELEASE = 1;
export const RT_CALIBRATE_PHASE_PRESS = 2;
export const RT_CALIBRATE_SAVE = 0xff;
export const RT_CALIBRATE_STEP_MS = 5000;
/** 按下阶段开始前的准备倒计时，由用户点击按钮触发 */
export const RT_CALIBRATE_COUNTDOWN_MS = 3000;

export const isRtCalibratePhase = (value) =>
  Number(value) === RT_CALIBRATE_PHASE_RELEASE ||
  Number(value) === RT_CALIBRATE_PHASE_PRESS;

export const isRtCalibrateValue = (value) =>
  isRtCalibratePhase(value) || Number(value) === RT_CALIBRATE_SAVE;

/**
 * 组装校准控制包。byte3 固定为 RT_CALIBRATE_TYPE，byte4 是唯一的数据字节。
 * @param {number} value - 1 放开 / 2 按下 / 0xFF 保存
 * @returns {Uint8Array}
 */
export function encodeRtCalibrateControl(value) {
  if (!isRtCalibrateValue(value)) {
    throw new Error('RT 校准只能发 1（放开）、2（按下）或 0xFF（保存）');
  }
  const data = new Uint8Array(64);
  data[0] = RT_CALIBRATE_COMMAND;
  data[1] = 0x00;
  data[2] = 0x80 | 1;
  data[3] = RT_CALIBRATE_TYPE;
  data[4] = Number(value);
  return data;
}

/**
 * 设备回显的校准控制包。不当作性能数据或 RT 采样。
 * @param {Uint8Array|number[]|null} data
 */
export function isRtCalibratePacket(data) {
  if (!data || data.length < 5) return false;
  if (parseCommandByte(data[0]).command !== RT_CALIBRATE_COMMAND) return false;
  if (data[3] !== RT_CALIBRATE_TYPE) return false;
  return isRtCalibrateValue(data[4]);
}
